import { MARKETING_ROLE_PAGE_CONTENT_A } from './role-page-content-a';
import { MARKETING_ROLE_PAGE_CONTENT_B } from './role-page-content-b';
import type { MarketingRoleSlug } from './role-page-model';
import type { MarketingRolePageSource } from './role-page-content.types';
import { ROLE_TESTIMONIALS } from './role-testimonials-content';

export const MARKETING_ROLE_PAGE = {
  overline: 'Instant collections',
  titleLead: 'IMAI for',
  whyLabel: 'Why {role} Use IMAI',
  processLabel: 'From Concept to Customer',
  processHeading: 'Keep the Idea Yours at Every Stage.',
  processBody:
    'One connected story from creative territory to factory to launch and selling — direction, decisions, and details intact.',
  processCta: 'Build your Creative Direction',
  processCtaHref: '/auth?mode=signup',
  mobileProcessCta: 'Get Started with IMAI Now',
  testimonials: ROLE_TESTIMONIALS,
  stages: [
    {
      number: '01',
      title: 'Design with Taste',
      body: 'Bring the brief, references, palette, materials, budget, and brand context into one starting point. Explore collections, trends, and your vision in IMAI.',
    },
    {
      number: '02',
      title: 'Manufacture with Ease',
      body: 'The approved direction becomes factory-ready today: specs, measurements, and materials in your own templates and terminology.',
    },
    {
      number: '03',
      title: 'Sell with Profit',
      body: 'The product arrives on time and on the number you planned. Create marketing assets with real materials, real colors and real stories.',
    },
  ],
} as const;

const MARKETING_ROLE_CONTENT: Record<
  MarketingRoleSlug,
  MarketingRolePageSource
> = {
  ...MARKETING_ROLE_PAGE_CONTENT_A,
  ...MARKETING_ROLE_PAGE_CONTENT_B,
};

export function getMarketingRolePageContent(
  slug: MarketingRoleSlug
): MarketingRolePageSource {
  return MARKETING_ROLE_CONTENT[slug];
}
